import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AsapService, Global } from 'asap-crud';
import { range } from 'rxjs';
import { LOCATIONS } from './locations';
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import { ActivatedRoute } from '@angular/router';


@Component({
    selector: 'app-curriculum',
    templateUrl: './curriculum.component.html',
    styleUrls: ['./curriculum.component.scss'],
})
export class CurriculumComponent implements OnInit, OnChanges {

    @Input() userID;
    @Input() hideEditTab = false;

    public infoUser: any;
    public curriculum: any;
    public index: number = 0;
    public entity: any = {};
    public years: any = [];
    public citySelected: any;
    public loading: boolean = false;

    public originURL;
    public referenceURL;

    public curriculumTips = {
        pessonalData: 'Preencha as principais informações sobre você.',
        name: 'Preencha seu nome completo.',
        state: 'Coloque seu estado.',
        profission: 'Caso não possua experiencia profissional, você pode colocar “Jovem Aprendiz” ou “Ingressar no mercado de trabalho”',
        contact: 'Não esqueça também de colocar contatos atualizados e que você veja com frequência, para garantir que não vai perder nenhuma mensagem ou oportunidade.',
        url: 'Em URL, coloque o link do seu site ou portfólio, caso possua.',
        resume: 'Aqui é importante atenção e carinho. Você deve escrever um pequeno texto sobre marcos importantes da sua história de vida que fazem você ter características únicas e ser quem é. Cite as suas experiências, conquistas, aprendizados, anseios e pontos de destaque. Seja você!',
        experience: 'Adicione cada uma das suas experiências de trabalho ou emprego, tanto em trabalhos formais quanto informais. Não precisam ser, necessariamente, atividades remuneradas. Preencha também com aquele canal no YouTube, peça do teatro, estágio não remunerado e até mesmo aquele TCC que entregou.',
        volunter: 'Já ajudou alguma instituição social ou grupo de pessoas de sua região? Pode ser uma creche, escola, igreja, associação de moradores, etc. Alguma de suas experiências teve a ver com alguma causa específica? Se sim, conte como foi e o que aprendeu.',
        formation: 'Esse espaço é reservado para que conte a sua trajetória nos estudos. Ensino médio, cursos livres, cursos profissionalizantes, universidade e pós-graduação.',
        language: 'Coloque aqui os idiomas que você entende, dizendo, para cada um deles, qual o seu nível de habilidade em falar, ler e escrever o mesmo e registre aqui a sua capacidade de se comunicar com o mundo.',
        cert: 'Faça o upload daquele programa de educação especial, curso, evento e palestra que participou ou daquele prêmio que ganhou.',
        comport: 'Responda o questionário clicando no botão abaixo e torne visível o seu perfil comportamental. Muitas empresas, além de conhecer suas habilidades e conhecimentos, também levam em conta os aspectos comportamentais. '
    };

    public states = [
        'Acre',
        'Alagoas',
        'Amapá',
        'Amazonas',
        'Bahia',
        'Ceará',
        'Distrito Federal',
        'Espírito Santo',
        'Goiás',
        'Maranhão',
        'Mato Grosso',
        'Mato Grosso do Sul',
        'Minas Gerais',
        'Pará',
        'Paraíba',
        'Paraná',
        'Pernambuco',
        'Piauí',
        'Rio de Janeiro',
        'Rio Grande do Norte',
        'Rio Grande do Sul',
        'Rondônia',
        'Roraima',
        'Santa Catarina',
        'São Paulo',
        'Sergipe',
        'Tocantins'
    ];

    public months = [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro'
    ];

    constructor(
        public asapService: AsapService,
        public global: Global,
        public route: ActivatedRoute
    ) {

        this.route.queryParams.subscribe(queryParam => {
            this.originURL = queryParam['origin'];
            this.referenceURL = queryParam['ref'];
        });
    }

    ngOnInit(): void {
        if (!this.userID) {
            this.infoUser = this.global.loggedUser();
            this.setYears();
            this.getDataCurriculum();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.userID) {
            if (this.userID != this.global.loggedUser().id) {
                this.hideEditTab = true;
            }
            this.setYears();
            this.getDataCurriculum(this.userID);
        }
    }

    public normalizeCurriculum(curriculum) {
        if (curriculum) {
            if (Array.isArray(curriculum.folks)) {
                curriculum.folks = {nome:''};
            }
            if (Array.isArray(curriculum.experience[0])) {
                curriculum.experience[0] = {empresa:''};
            }
            if (Array.isArray(curriculum.volunteering[0])) {
                curriculum.volunteering[0] = {organizacao:''};
            }
            if (Array.isArray(curriculum.formation[0])) {
                curriculum.formation[0] = {curso:''};
            }
            if (Array.isArray(curriculum.languages[0])) {
                curriculum.languages[0] = {idioma:''};
            }
            if (curriculum.cert && curriculum.cert.length && Array.isArray(curriculum.cert[0])) {
                curriculum.cert[0] = {title:''};
            }
        }
        return curriculum;
    }

    public getDataCurriculum(id = null): void {
        let params: any = {};
        this.asapService.basePath = "api/v2/client";
        this.asapService.entityName = "curriculum";

        if (id) {
            params.router = id;
        }

        this.loading = true;
        this.asapService.getResources(params).subscribe((response: any) => {
            if (response.data.length) {
                this.entity = this.normalizeCurriculum(response.data[0]);
                if (this.entity) {
                    this.curriculum = this.normalizeCurriculum(JSON.parse(JSON.stringify(this.entity)));
                    this.setCity({value:this.entity.folks.estado});
                }
            }
            this.loading = false;
        });
    }

    public saveDataCurriculum(entity): void {
        this.asapService.basePath = "api/v2/client";
        this.asapService.entityName = "curriculum";
        this.asapService.createResource(entity).subscribe((response: any) => {
            this.index = 0;
            this.global.toast("Informações salvas com sucesso!");
            this.curriculum = this.normalizeCurriculum(response.data);
        });

    }

    public addCurriculum(): void {
        this.entity = {
            folks: {nome:''},
            experience: [{empresa:''}],
            volunteering: [{organizacao:''}],
            formation: [{curso:''}],
            languages: [{idioma:''}],
            cert: [],
            comport: null,
            video: null,
            user_id: this.infoUser.id
        };

        this.index = 1;

        window.scrollTo(0,0);
    }

    public addExperience(): void {
        this.entity.experience.push({empresa:''});
    }

    public removeExperience(index: number): void {
        this.entity.experience.splice(index, 1);
    }

    public addVolunteering(): void {
        this.entity.volunteering.push({organizacao:''});
    }

    public removeVolunteering(index: number): void {
        this.entity.volunteering.splice(index, 1);
    }

    public addFormation(): void {
        this.entity.formation.push({curso:''});
    }

    public removeFormation(index: number): void {
        this.entity.formation.splice(index, 1);
    }

    public addLanguage(): void {
        this.entity.languages.push({idioma:''});
    }

    public removeLanguage(index: number): void {
        this.entity.languages.splice(index, 1);
    }

    public removeCert(index: number): void {
        this.entity.cert.splice(index, 1);
    }

    public tabClick(event): void {
        if (event.index == 1) {

            this.index = 1;
        }
        else {
            this.index = 0;
        }
    }

    public setCity(event: any): void {
        LOCATIONS.estados.forEach(city => {
            if (city.nome == event.value) {
                this.citySelected = city.cidades;
            }
        });
    }

    public setYears(): void {
        let year = range(1980, 51);
        let i = 0;
        year.subscribe(response => {
            this.years[i] = response;
            i++;
        });
    }

    public asapUpload(certificates): void {
        let asapUpload: any = this.global.getSessionData('asap-upload');
        if (asapUpload) {
            asapUpload.type = 'file';
            // asapUpload.onlyType = 'image/*';
            asapUpload.aspectRatio = 1;
            asapUpload.resizeToWidth = 800;
            let imgSubs = asapUpload.AddArchive.subscribe(image => {
                certificates.push({
                    title: image.name,
                    file: image
                });
                imgSubs.unsubscribe();
                imgCancel.unsubscribe();
            });

            let imgCancel = asapUpload.onCancel.subscribe(() => {
                imgSubs.unsubscribe();
                imgCancel.unsubscribe();
            });

            asapUpload.openDialog();
        }
        else {
            this.global.toastService.show({
                title: 'Módulo de upload não acoplado...',
                position: "topRight",
                color: '#990000',
                titleColor: 'white',
                transitionOut: 'flipOutX',
                transitionIn: 'flipInX',
            });
        }
    }

    public isEmptyObject(obj): any {
        return (obj && (Object.keys(obj).length === 0));
    }

    public convetToPDF() {
        let data = document.getElementById('curriculum');  //Id of the table
        data.style.zoom = `${data.clientWidth/900}`;
        html2canvas(data, { allowTaint: true, useCORS: true, scale: 4 }).then(canvas => {
            data.style.zoom = '1';
            let margin = 10;
            let imgWidth = 210;
            let imgHeight = canvas.height * imgWidth / canvas.width;
            let pageHeight = 297;
            let marginAcm = 0;
            
            const contentDataURL = canvas.toDataURL('image/jpeg', 0.5);
            let pdf = new jsPDF({
                orientation: 'p', 
                unit: 'mm'
            });
            
            let position = 10;
            
            let totalPDFPages = Math.ceil(imgHeight/pageHeight)-1;

            pdf.addImage(contentDataURL, margin, margin, imgWidth - (2*margin), imgHeight);
            pdf.setFillColor('#FFFFFF');
            pdf.rect(0, 0, imgWidth, margin, 'F');
            pdf.rect(0, pageHeight-margin, imgWidth, margin, 'F');
            marginAcm += (3*margin);

            for (var i = 1; i <= totalPDFPages; i++) { 
				pdf.addPage("a4");
				pdf.addImage(contentDataURL, 'JPG', margin, -(pageHeight*i)+marginAcm,imgWidth - 30,imgHeight);
                pdf.setFillColor('#FFFFFF')
                pdf.rect(0, 0, imgWidth, margin, 'F');
                pdf.rect(0, pageHeight-margin, imgWidth, margin, 'F');
                marginAcm += (2*margin);
			}

            pdf.save('curriculum.pdf'); // Generated PDF   

        });
    }

    public reload() {
        window.location.reload();
    }
}
